/**
 * Utilitário centralizado para detecção de ambiente.
 * Usar SEMPRE este módulo em vez de checar import.meta.env diretamente.
 *
 * - isDevEnvironment(): true em localhost OU ambiente .dev.agendario.com.br
 * - isLocalhost(): true apenas em localhost
 * - isProduction(): true apenas no ambiente de produção (sem .dev.)
 */
import { authService } from '../services/authService';

export function isDevEnvironment() {
  return (
    import.meta.env.DEV ||
    import.meta.env.MODE === 'development' ||
    import.meta.env.VITE_API_URL?.includes('.dev.') ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('.dev.')
  );
}

export function isLocalhost() {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}

export function isProduction() {
  return !isDevEnvironment();
}

/**
 * Venda de planos (assinatura/cartão) fica OCULTA por padrão durante o go-live de pacotes (PIX).
 * Liga apenas com VITE_FEATURE_PLANS_SALE === 'true'. Default OFF (kill-switch da venda de planos).
 */
export function isPlansSaleEnabled() {
  return import.meta.env.VITE_FEATURE_PLANS_SALE === 'true';
}

/**
 * Venda de domínio próprio.
 *
 * Oculta por padrão. A rota `/domains` existe hoje para o ciclo de design — é onde o card é
 * desenhado e revisado isolado. O destino dele é ser embutido na Home e em Páginas (o domínio é
 * atributo do site que o cliente já administra ali, não um item de menu). Ligar só se um dia
 * decidirmos que a gestão de domínios merece tela própria.
 */
export function isDomainSalesEnabled() {
  return import.meta.env.VITE_FEATURE_DOMAIN_SALES === 'true';
}

/**
 * Admin do sistema (Blasoft) — MESMA definição do backend (API AdminOnlyHandler /
 * Login IsBlasoftAdmin): e-mail em domínio @blasoft.* ou na lista explícita.
 * Lê o claim `email` do JWT logado. Fail-closed: sem token/sem e-mail ⇒ false.
 * ⚠️ Gate de VISIBILIDADE (soft-launch), não de segurança — a autorização real
 * de endpoints admin continua na policy AdminOnly da API.
 */
export function isBlasoftAdminUser() {
  const email = authService.getUserInfo()?.email?.toLowerCase() ?? '';
  if (!email) return false;
  return (
    email === 'andremansur@gmail.com' ||
    email.endsWith('@blasoft.dev') ||
    email.endsWith('@blasoft.com.br')
  );
}

/**
 * Tela de Integrações (WhatsApp: config + vitrine de pacotes PIX + histórico).
 * LIBERADA PARA TODOS (go-live). O kill-switch continua existindo, mas invertido:
 * só oculta se o build vier com VITE_FEATURE_INTEGRATIONS === 'false' (emergência).
 */
export function isIntegrationsEnabled() {
  return import.meta.env.VITE_FEATURE_INTEGRATIONS !== 'false';
}
